// Message rotation interval in milliseconds
export const MESSAGE_ROTATION_INTERVAL = 5000;

// Animation duration should match the rotation interval
export const MESSAGE_ANIMATION_DURATION = MESSAGE_ROTATION_INTERVAL / 1000; // Convert to seconds for CSS
